import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AccordionFullTable, FullTable, NoItemsYet } from 'components';
import { sortListByKey } from 'utils';
import { appointmentActions } from 'store';
import { scheduleDataCollectionNotYet, scheduleDataCollectionTableInfo } from './constants';
import { trialDataBodyBody, trialDataHead } from '../../../client/clientSingle/clientClinical/goals/trialData/constants';

export const ScheduleDataCollection = ({ appt }) => {
    const { apptDataCollection, item } = useSelector((state) => ({
        item: state.appointment.appointmentById,
        apptDataCollection: state.appointment.apptDataCollection,
    }));
    const dispatch = useDispatch();
    const [params, setParams] = useState({});

    useEffect(() => {
        if (appt?.cSession?.id) {
            dispatch(appointmentActions.getApptDataCollection(appt.cSession.id));
        }
    }, []);

    return (
        <div>
            {/*<div className="flex-end">*/}
            {/*   <DownloadCsv type={'apptSession'} params={{sessionId: appt?.cSession?.id}} linkBtn={true} />*/}
            {/*</div>*/}

            <AccordionFullTable
                margin={'12px 0 0 0'}
                getParams={setParams}
                savedParams={params}
                tableInfo={scheduleDataCollectionTableInfo()}
                list={sortListByKey(apptDataCollection, 'goalName', params)}
                renderAccordionDetails={(item) => {
                    return (
                        <div>
                            {item?.tSummary?.trials?.length > 0 ? (
                                <div>
                                    {item?.tSummary?.trials?.length && (
                                        <FullTable
                                            accordionBody={true}
                                            head={trialDataHead(item?.dataType)}
                                            body={trialDataBodyBody(item?.dataType)}
                                            list={item?.tSummary?.trials}
                                            notYet={scheduleDataCollectionNotYet}
                                            height={'extraSmall'}
                                            activeRowId={''}
                                            margin={'0'}
                                        />
                                    )}
                                </div>
                            ) : (
                                <div style={{ height: scheduleDataCollectionNotYet?.height }}>
                                    <NoItemsYet
                                        height={scheduleDataCollectionNotYet?.height}
                                        text={'Session don’t have Targets yet'}
                                        subTitle={scheduleDataCollectionNotYet.subTitle}
                                        image={scheduleDataCollectionNotYet.image}
                                    />
                                </div>
                            )}
                        </div>
                    );
                }}
                containerStyles={{ position: 'relative', height: '450px' }}
            />
        </div>
    );
};
